<template>
    <a-row :gutter="[16,16]">
        <a-col :span='6'>

            <div class="staticNum color1">
                <p class="numTitle">
                    系統数量
                </p>
                <p class="numValue">
                    <span>{{data.SysCount.todaycount}}</span> 今日
                </p>
                <p class="numValue">
                    <span>{{data.SysCount.lastdaycount}}</span> 昨日
                </p>
            </div>
        </a-col>
        <a-col :span='6'>
            <div class="staticNum color2">
                <p class="numTitle">
                    异常名种类
                </p>
                <p class="numValue">
                    <span>{{data.MsgCount.todaymsgcount}}</span> 今日
                </p>
                <p class="numValue">
                    <span>{{data.MsgCount.lastdaymsgcount}}</span> 昨日
                </p>
            </div>
        </a-col>

        <a-col :span='6'>
            <div class="staticNum color3">
                <p class="numTitle">
                    精细化异常类型
                </p>
                <p class="numValue">
                    <span>{{data.ClassCount.todayclasscount}}</span> 今日
                </p>
                <p class="numValue">
                    <span>{{data.ClassCount.lastdayclasscount}}</span> 昨日
                </p>
            </div>
        </a-col>
        <a-col :span='6'>
            <div class="staticNum color4">
                <p class="numTitle">
                    异常总数
                </p>
                <p class="numValue">
                    <span>{{data.SumCount.todaysumcount}}</span> 今日
                </p>
                <p class="numValue">
                    <span>{{data.SumCount.lastdaysumcount}}</span> 昨日
                </p>
            </div>
        </a-col>
    </a-row>
</template>

<script>
export default {
    data(){
        return {

        }
    },
    props:{
        data:{
            
            SysCount:{
                lastdaycount: "",
                todaycount: ""
            },
            MsgCount:{
                lastdaymsgcount: "",
                todaymsgcount: ""
            },
            ClassCount:{
                lastdayclasscount: "",
                todayclasscount: ""
            },
            SumCount:{
                lastdaysumcount: "",
                todaysumcount: ""
            }

        }
    },
    methods:{
        
    },
    mounted(){
    }
};
</script>

<style lang="less" scoped>
.content{
  background-color: #f0f2f5; padding: 20px;min-width:900px;
}

.staticNum{
    width:100%;
    height:auto;
    background-color: white;
    padding: 4px 10px;
    color: white;
    text-align: right;
}

.numTitle{
    margin-bottom: 4px;
    font-size: 16px;
    opacity: 0.9;
}

.numValue{
    font-size: 12px;
    padding: 0;
    margin: 2px 0;
    opacity: 0.8;
}

.numValue span{
    font-size: 16px;
}

.color1{
    background-color:#4c87b9;
}

.color2{
    background-color:#d05454;
}

.color3{
    background-color:#3faba4;
}

.color4{
    background-color:#8877a9;
}
</style>
